/* Nova Milano — extras: zoom, delivery estimate, wishlist, recently viewed, cart upsell, card swatches, videos */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const NM = window.NM || {};
  const cfg = NM.extras || {};
  const root = ((NM.routes && NM.routes.root) || '/').replace(/\/$/, '');
  const url = (p) => root + p;
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (cents) => (cents / 100).toLocaleString('hr-HR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  const shortName = (t) => String(t).split(' – ')[0];
  const img = (src, w) => { if (!src) return ''; let s = src.startsWith('//') ? 'https:' + src : src; return s + (s.includes('?') ? '&' : '?') + 'width=' + w; };
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (_) { return []; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} }
  };
  const productCache = {};
  async function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(url('/products/' + handle + '.js')).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    return productCache[handle];
  }
  function toast(msg) {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }
  async function refreshDrawer() {
    try {
      const r = await fetch(url('/?sections=cart-drawer'));
      const html = (await r.json())['cart-drawer'];
      const fresh = $('[data-cart-drawer]', new DOMParser().parseFromString(html, 'text/html'));
      const cur = $('[data-cart-drawer]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      const cart = await (await fetch(url('/cart.js'))).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (_) {}
  }
  async function addVariant(id, open) {
    const r = await fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
    if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.description || (NM.strings && NM.strings.error) || 'Greška'); }
    await refreshDrawer();
    if (open) { const o = $('[data-cart-open]'); o && o.click(); }
    toast((NM.strings && NM.strings.added) || 'Dodano');
  }
  const heartSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.7 7.8 3.8 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.4 0 5.5 3.3 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4Z"/></svg>';

  /* ---------- 1. Lightbox zoom ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const slides = $$('[data-pp-slide] img', pdp);
    if (slides.length) {
      const lb = document.createElement('div');
      lb.className = 'lb'; lb.hidden = true; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<button type="button" class="lb__close" aria-label="Zatvori">✕</button>' +
        '<button type="button" class="lb__nav lb__nav--prev" aria-label="Prethodna">‹</button><button type="button" class="lb__nav lb__nav--next" aria-label="Sljedeća">›</button>' +
        '<div class="lb__track">' + slides.map((im) => {
          const w = Math.min(2400, Math.ceil(Math.max(window.innerWidth, window.innerHeight * 0.8) * Math.min(window.devicePixelRatio || 1, 2.5) / 100) * 100);
          const base = (im.currentSrc || im.src);
          const big = /width=\d+/.test(base) ? base.replace(/width=\d+/, 'width=' + w) : base + (base.includes('?') ? '&' : '?') + 'width=' + w;
          return '<div class="lb__slide"><img src="' + esc(big) + '" alt="' + esc(im.alt) + '" loading="lazy"></div>';
        }).join('') + '</div><span class="lb__count"></span>';
      document.body.appendChild(lb);
      const track = $('.lb__track', lb), count = $('.lb__count', lb);
      const cur = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
      const sync = () => { count.textContent = (cur() + 1) + ' / ' + slides.length; };
      const go = (i) => { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
      let last = null;
      let openedAt = 0;
      const touch = window.matchMedia('(pointer: coarse)').matches;
      const open = (i) => {
        openedAt = Date.now();
        last = document.activeElement; lb.hidden = false; document.body.style.overflow = 'hidden';
        track.scrollLeft = i * track.clientWidth; sync(); $('.lb__close', lb).focus();
      };
      const close = () => { lb.hidden = true; document.body.style.overflow = ''; $$('.lb__slide', lb).forEach((s) => s.classList.remove('is-zoomed')); last && last.focus(); };
      slides.forEach((im, i) => im.addEventListener('click', () => open(i)));
      $('.lb__close', lb).addEventListener('click', close);
      $('.lb__nav--prev', lb).addEventListener('click', () => go(cur() - 1));
      $('.lb__nav--next', lb).addEventListener('click', () => go(cur() + 1));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      $$('.lb__slide', lb).forEach((s) => s.addEventListener('click', (e) => {
        if (Date.now() - openedAt < 450) return; // ignore the "ghost" tap that opened the lightbox (Android)
        if (e.target.tagName !== 'IMG') return close();
        if (touch) return; // phones: use native pinch-to-zoom instead of 2x tap zoom
        const z = !s.classList.contains('is-zoomed');
        s.classList.toggle('is-zoomed', z);
        if (z) { const r = e.target.getBoundingClientRect(); requestAnimationFrame(() => { s.scrollLeft = (e.clientX - r.left) / r.width * s.scrollWidth - s.clientWidth / 2; s.scrollTop = (e.clientY - r.top) / r.height * s.scrollHeight - s.clientHeight / 2; }); }
      }));
      document.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') go(cur() + 1);
        if (e.key === 'ArrowLeft') go(cur() - 1);
      });
    }
  }

  /* ---------- 2+3. Delivery estimate & free shipping (PDP) ---------- */
  if (pdp && cfg.delivery !== false) {
    const anchor = $('.pp__stock', pdp) || $('[data-pp-buttons]', pdp);
    if (anchor) {
      const days = ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'];
      const months = ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenoga', 'prosinca'];
      const addBiz = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) k++; } return x; };
      const fmt = (d) => days[d.getDay()] + ' ' + d.getDate() + '. ' + months[d.getMonth()];
      const now = new Date();
      let start = new Date(now);
      const weekend = now.getDay() === 0 || now.getDay() === 6;
      const late = now.getHours() >= (cfg.cutoff || 14);
      const extra = (late || weekend) ? 1 : 0;
      const from = addBiz(start, (cfg.min || 2) + extra), to = addBiz(start, (cfg.max || 5) + extra);
      const truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2 6h12v10H2zM14 10h4l3 3v3h-7"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';
      const gift = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="9" width="18" height="4"/><path d="M5 13v8h14v-8M12 9v12M12 9c-1.5-3-5-4-5-1.5S12 9 12 9Zm0 0c1.5-3 5-4 5-1.5S12 9 12 9Z"/></svg>';
      const box = document.createElement('div');
      box.className = 'pp-perks';
      box.innerHTML = '<div class="pp-perk">' + truck + '<div>' + (late || weekend ? 'Naručite sada' : 'Naručite danas') + ' – stiže između <strong>' + fmt(from) + '</strong> i <strong>' + fmt(to) + '</strong></div></div>';
      anchor.insertAdjacentElement('afterend', box);
      const threshold = (cfg.freeShipping || 0) * 100;
      if (threshold > 0) {
        const perk = document.createElement('div'); perk.className = 'pp-perk'; box.appendChild(perk);
        const render = async () => {
          let total = 0;
          try { total = (await (await fetch(url('/cart.js'))).json()).total_price; } catch (_) {}
          const json = $('[data-pp-json]', pdp), idIn = $('[data-pp-variant]', pdp);
          let price = 0;
          if (json && idIn) { const v = JSON.parse(json.textContent).variants.find((x) => String(x.id) === idIn.value); price = v ? v.priceCents : 0; }
          const after = total + price, left = threshold - after, pct = Math.min(100, Math.round(after / threshold * 100));
          perk.innerHTML = gift + '<div style="flex:1">' + (left > 0 ? 'Uz ovu torbicu još <strong>' + money(left) + '</strong> do besplatne dostave' : 'Uz ovu torbicu ostvarujete <strong>besplatnu dostavu</strong>') +
            '<div class="pp-perk__bar"><span style="width:' + pct + '%"></span></div></div>';
        };
        render();
        $$('input[data-pp-option]', pdp).forEach((i) => i.addEventListener('change', () => setTimeout(render, 50)));
        document.addEventListener('nm:cart', render);
      }
    }
  }

  /* ---------- 4. Wishlist ---------- */
  const WL = 'nm-wishlist';
  const wl = () => store.get(WL);
  const isOn = (h) => wl().includes(h);
  function toggle(h) {
    const l = wl(); const i = l.indexOf(h);
    if (i >= 0) l.splice(i, 1); else l.unshift(h);
    store.set(WL, l.slice(0, 50)); syncHearts();
    toast(i >= 0 ? 'Uklonjeno iz favorita' : 'Spremljeno u favorite ❤');
  }
  function syncHearts() {
    $$('[data-wl]').forEach((b) => { const on = isOn(b.dataset.wl); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
    const n = wl().length;
    $$('.wl-count').forEach((c) => { c.textContent = n; c.hidden = n === 0; });
  }
  const handleFrom = (href) => { const m = String(href).match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; };
  function decorateCards(scope) {
    $$('.card__frame', scope).forEach((f) => {
      if ($('[data-wl]', f)) return;
      const a = $('a.card__media', f); const h = a && handleFrom(a.getAttribute('href'));
      if (!h) return;
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'wl-heart'; b.dataset.wl = h; b.setAttribute('aria-label', 'Spremi u favorite'); b.innerHTML = heartSvg;
      f.appendChild(b);
    });
    syncHearts();
  }
  // header icon
  const actions = $('.header__actions'), cartLink = $('.header__cart');
  if (actions && cartLink) {
    const o = document.createElement('button');
    o.type = 'button'; o.className = 'header__icon wl-open'; o.setAttribute('aria-label', 'Favoriti');
    o.innerHTML = heartSvg + '<span class="wl-count" hidden>0</span>';
    actions.insertBefore(o, cartLink);
    o.addEventListener('click', openWl);
  }
  // PDP heart
  if (pdp) {
    const h = handleFrom(location.pathname), title = $('.pp__title', pdp);
    if (h && title) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'wl-heart wl-heart--pdp'; b.dataset.wl = h;
      b.innerHTML = heartSvg + '<span>Spremi u favorite</span>';
      const anchor = $('.pp__tax', pdp) || title;
      anchor.insertAdjacentElement('afterend', b);
    }
  }
  const panel = document.createElement('div');
  panel.className = 'wl'; panel.hidden = true;
  panel.innerHTML = '<div class="wl__overlay" data-wl-close></div><aside class="wl__panel" role="dialog" aria-modal="true" aria-label="Favoriti"><div class="wl__head"><p class="wl__title">Favoriti</p><button type="button" class="header__icon" data-wl-close aria-label="Zatvori">✕</button></div><div class="wl__body"></div></aside>';
  document.body.appendChild(panel);
  async function openWl() {
    panel.hidden = false; document.body.style.overflow = 'hidden';
    const body = $('.wl__body', panel), list = wl();
    if (!list.length) { body.innerHTML = '<p class="wl__empty">Još nemate spremljenih torbica.<br>Dodirnite ❤ na proizvodu da ga spremite.</p>'; return; }
    body.innerHTML = '<p class="wl__empty">Učitavanje…</p>';
    const items = (await Promise.all(list.map(getProduct))).filter(Boolean);
    body.innerHTML = items.map((p) => {
      const v = p.variants.find((x) => x.available);
      return '<div class="wl-item"><a class="wl-item__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="wl-item__name" href="' + esc(p.url) + '">' + esc(shortName(p.title)) + '</a><div class="wl-item__price">' + money(p.price) + '</div></div>' +
        '<div class="wl-item__actions">' + (v && p.price > 0 ? '<button type="button" class="mini-add" data-add="' + v.id + '">Dodaj</button>' : '<span class="wl-item__price">Rasprodano</span>') +
        '<button type="button" class="wl-item__remove" data-wl-remove="' + esc(p.handle) + '">Ukloni</button></div></div>';
    }).join('');
  }
  const closeWl = () => { panel.hidden = true; document.body.style.overflow = ''; };
  document.addEventListener('click', async (e) => {
    const heart = e.target.closest('[data-wl]');
    if (heart) { e.preventDefault(); toggle(heart.dataset.wl); return; }
    if (e.target.closest('[data-wl-close]')) { closeWl(); return; }
    const rm = e.target.closest('[data-wl-remove]');
    if (rm) { toggle(rm.dataset.wlRemove); openWl(); return; }
    const add = e.target.closest('[data-add]');
    if (add) {
      add.disabled = true;
      try { const fromWl = add.closest('.wl'); if (fromWl) closeWl(); await addVariant(add.dataset.add, true); document.dispatchEvent(new CustomEvent('nm:cart')); }
      catch (err) { toast(err.message); } finally { add.disabled = false; }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) closeWl(); });
  decorateCards(document);
  new MutationObserver((muts) => { if (muts.some((m) => m.addedNodes.length)) decorateCards(document); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

  /* ---------- 5. Recently viewed ---------- */
  const RV = 'nm-recent';
  if (pdp) {
    const h = handleFrom(location.pathname);
    if (h) {
      const prev = store.get(RV).filter((x) => x !== h);
      store.set(RV, [h].concat(prev).slice(0, 12));
      const show = prev.slice(0, 8);
      if (show.length) {
        (async () => {
          const items = (await Promise.all(show.map(getProduct))).filter((p) => p && p.price > 0);
          if (!items.length) return;
          const sec = document.createElement('section');
          sec.className = 'rv';
          sec.innerHTML = '<h2 class="rv__title">Nedavno pregledano</h2><div class="rv__row">' + items.map((p) =>
            '<a class="rv-card" href="' + esc(p.url) + '"><span class="rv-card__img">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 460)) + '" alt="' + esc(shortName(p.title)) + '" loading="lazy">' : '') + '</span>' +
            '<span class="rv-card__name">' + esc(shortName(p.title)) + '</span><span class="rv-card__price">' + money(p.price) + '</span></a>').join('') + '</div>';
          const main = $('#MainContent'); main && main.appendChild(sec);
        })();
      }
    }
  }

  /* ---------- 6. Cart upsell ---------- */
  let upsellBusy = false;
  async function upsell() {
    const body = $('[data-cart-drawer] .drawer__body');
    if (!body || upsellBusy || $('.upsell', body) || !$('.line-items', body)) return;
    upsellBusy = true;
    try {
      const cart = await (await fetch(url('/cart.js'))).json();
      if (!cart.items.length) return;
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const get = async (intent) => {
        const r = await fetch(url('/recommendations/products.json') + '?product_id=' + cart.items[0].product_id + '&limit=8&intent=' + intent);
        return r.ok ? ((await r.json()).products || []) : [];
      };
      let recs = (await get('complementary')).concat(await get('related'));
      const seen = new Set();
      recs = recs.filter((p) => p.available && p.price > 0 && !inCart.has(p.id) && !seen.has(p.id) && seen.add(p.id)).slice(0, 6);
      if (!recs.length || $('.upsell', body)) return;
      const box = document.createElement('div');
      box.className = 'upsell';
      box.innerHTML = '<p class="upsell__title">Dodajte uz narudžbu</p><div class="upsell__row">' + recs.map((p) => {
        const v = p.variants.find((x) => x.available);
        return '<div class="upsell-item"><a class="upsell-item__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 260)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<span class="upsell-item__name">' + esc(shortName(p.title)) + '</span><span class="upsell-item__price">' + money(p.price) + '</span>' +
          '<button type="button" class="mini-add" data-add="' + v.id + '">Dodaj +</button></div>';
      }).join('') + '</div>';
      body.appendChild(box);
    } catch (_) {} finally { upsellBusy = false; }
  }
  const drawerEl = $('[data-cart-drawer]');
  if (drawerEl) {
    new MutationObserver(() => upsell()).observe(drawerEl, { childList: true });
    new MutationObserver(() => { if (drawerEl.classList.contains('is-open')) upsell(); }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 7. Card colour swatches ---------- */
  document.addEventListener('mouseover', swatchSwap);
  document.addEventListener('click', (e) => { if (e.target.closest('.card-swatch')) { e.preventDefault(); swatchSwap(e); } });
  function swatchSwap(e) {
    const s = e.target.closest && e.target.closest('.card-swatch');
    if (!s) return;
    const card = s.closest('.card'); const main = card && $('.card__img:not(.card__img--alt)', card);
    if (!main || !s.dataset.img) return;
    main.removeAttribute('srcset'); main.src = s.dataset.img;
    $$('.card-swatch', card).forEach((x) => x.classList.toggle('is-active', x === s));
    const link = $('a.card__media', card); if (link && s.dataset.url) link.href = s.dataset.url;
  }

  /* ---------- 8. Video cards ---------- */
  $$('.video-card').forEach((c) => {
    const v = $('video', c), b = $('.video-card__play', c);
    if (!v || !b) return;
    const toggleV = () => { if (v.paused) { $$('.video-card video').forEach((o) => { if (o !== v) { o.pause(); o.closest('.video-card').classList.remove('is-playing'); } }); v.play(); c.classList.add('is-playing'); } else { v.pause(); c.classList.remove('is-playing'); } };
    b.addEventListener('click', toggleV); v.addEventListener('click', toggleV);
  });
})();
